// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AssetClassFromJSON, AssetClassToJSON, } from './';
export function DealFromJSON(json) {
    return {
        'fundId': !exists(json, 'fundId') ? undefined : json['fundId'],
        'fundName': !exists(json, 'fundName') ? undefined : json['fundName'],
        'startDate': !exists(json, 'startDate') ? undefined : new Date(json['startDate']),
        'exitDate': !exists(json, 'exitDate') ? undefined : new Date(json['exitDate']),
        'fundCurrency': !exists(json, 'fundCurrency') ? undefined : json['fundCurrency'],
        'assetClass': !exists(json, 'assetClass') ? undefined : AssetClassFromJSON(json['assetClass']),
    };
}
export function DealToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fundId': value.fundId,
        'fundName': value.fundName,
        'startDate': value.startDate === undefined ? undefined : value.startDate.toISOString(),
        'exitDate': value.exitDate === undefined ? undefined : value.exitDate.toISOString(),
        'fundCurrency': value.fundCurrency,
        'assetClass': AssetClassToJSON(value.assetClass),
    };
}
